import type { Service } from '../../stores/servicesStore';
import type { CategoryFilter } from '../../types/serviceCategory';

/**
 * The one place services are narrowed down for the list. Both the list view and
 * the provider's selection logic call it with the same arguments, so "select
 * all matching" can't drift from what the grid is actually showing.
 */
export const filterServices = (
	services: Service[],
	searchTerm: string,
	categoryFilter: CategoryFilter = 'all'
): Service[] => {
	const term = searchTerm.trim().toLowerCase();

	return services.filter(service => {
		if (categoryFilter === 'uncategorized') {
			if (service.categoryId != null) return false;
		} else if (typeof categoryFilter === 'number') {
			if (service.categoryId !== categoryFilter) return false;
		}

		if (!term) return true;

		return (
			service.name.toLowerCase().includes(term) ||
			service.description.toLowerCase().includes(term) ||
			(service.category ?? '').toLowerCase().includes(term)
		);
	});
};

export default filterServices;
